import React, { Component } from "react";
import "../App.css";
import { fetchAuthSession } from "@aws-amplify/auth";
import Utils from './../utils.js';

class RequestsApproverAddProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      proxyGroupName: "",
      appId: "",
      consumerName: "",
      deploymentEnvironment: "",
      buildEnvironment: "",
      adGroup: "",
      requestor: "",
      createdAt: "",
      buildUrl: "",
      requestorEmail: "",
      adGroupMembers: "",
      approverError: false,
      approverValidError: false,
      approverSubmitted: false,
      denialSubmitted: false,
      loggedInUser: "",
      isVisible: true,
      setIsVisible: false,
      requestSubmitted: false,
      isExpired: false,
      isFutureTime: false,
      requestDenied: false,
      requestFailed: false,
      approvedBy:"",
      deniedBy: "",
      adminEmails: "",
      domainName: "",
      skippedBuildEnvironment: "",
      isNewProduct: false
    };
    //Split the url alone
    this.URL = window.location.href.split("#")[0];
  }

  componentDidUpdate() {

  }

  componentDidMount() {

    this.consumeQueryParams();
  }

  validateRequest = async () => {

    let data = this.getStore();

    //API call
     let fetchAPIResponse  = {};
    try{
       let buildBody = {};
       buildBody = {
        status: Utils.FETCH_STATUS,
        buildUrl: data.buildUrl,
      };
        fetchAPIResponse = await Utils.approvalStatusAPICall(data, buildBody, "Add Product To Consumer API", "/add-product-to-consumer");

    }catch(error){
        // Fetching details from lambda failed
      this.setState({ requestFailed: true, isVisible: true });
      return;
    }
    if (fetchAPIResponse.status === Utils.APPROVED && (fetchAPIResponse.status !== Utils.DENIED || fetchAPIResponse.status !== Utils.FAILED)) {
      // if request is aready submitted
      this.setState({ approvedBy: fetchAPIResponse.approvedBy});
      this.setState({ requestDenied: false, isVisible: true });
      this.setState({ requestSubmitted: true, isVisible: true });
      return;
    } else if (fetchAPIResponse.status === Utils.DENIED && (fetchAPIResponse.status !== Utils.APPROVED || fetchAPIResponse.status !== Utils.FAILED)) {
      // if request is aready Denied
        this.setState({ deniedBy: fetchAPIResponse.deniedBy});
      this.setState({ requestSubmitted: false, isVisible: true });
      this.setState({ requestDenied: true, isVisible: true });
      return;
    } else if (fetchAPIResponse.status === Utils.FAILED) {
      // Fetching details from lambda failed
      this.setState({ requestFailed: true, isVisible: true });
      return;
    } else {
      const createdAtIntForm = parseInt(data.createdAt, 10);
      const createAtDate = new Date(createdAtIntForm);

      //To check if requst timestamp is not future date
      const isFutureDate = Utils.isFutureTimestamp(createAtDate);

      if(isFutureDate){
        this.setState({isFutureTime:true, isVisible: true });
        return;
      }
      var diffDays = Utils.isRequestExpired(createAtDate);

      if (diffDays > 3) {
        this.setState({ isExpired: true, isVisible: true });
        return;
      }
      if (data.requestorEmail === data.loggedInUser) {
        this.setState({ approverError: true, isVisible: true });
        return;
      } else if(data.adminEmails.includes(data.loggedInUser) ){
        this.setState({ approverValidError: false, isVisible: false });
        return;
      } else if (!data.adGroupMembers.includes(data.loggedInUser) ) {
        this.setState({ approverValidError: true, isVisible: true });
        return;
      }
    }
    this.setState({  isVisible: false });
    //ReachedHere- request is available for user action
  };

  convertStringToJson = (queryparamsJson) => {
    let parsedAppId = {};
    try {
      const appIdString = queryparamsJson.appId || '{}';
      // Convert {KEY:value,KEY2:value2} format to proper JSON
      const jsonString = appIdString
        .replace(/\{/g, '{"')
        .replace(/:/g, '":"')
        .replace(/,/g, '","')
        .replace(/\}/g, '"}');
      parsedAppId = JSON.parse(jsonString);
    } catch (e) {
      console.error('Error parsing appId:', e);
      // Try standard JSON parse as fallback
      this.setState({ isVisible: true });
      try {
        parsedAppId = JSON.parse(queryparamsJson.appId);
      } catch (e2) {
        console.error('Fallback parsing also failed:', e2);
        this.setState({ isVisible: true });
      }
    }
    return parsedAppId;
  };

  consumeQueryParams = async () => {

    const cognitoUserSession = await fetchAuthSession();
    const loggedInUser = cognitoUserSession.tokens.idToken.payload.email;
    let queryparamsJson = Utils.retrieveQueryParams();

    if(queryparamsJson){
      const parsedAppId = this.convertStringToJson(queryparamsJson);

      await this.setState({
        proxyGroupName: queryparamsJson.proxyGroupName,
        buildEnvironment: queryparamsJson.buildEnvironment,
        appId: parsedAppId,
        adGroup: queryparamsJson.adGroup,
        consumerName: queryparamsJson.consumerName,
        deploymentEnvironment: queryparamsJson.deploymentEnvironment,
        subBU: queryparamsJson.subBU,
        requestor: queryparamsJson.requestor,
        createdAt: queryparamsJson.createdAt,
        requestorEmail: queryparamsJson.requestorEmail,
        buildUrl: queryparamsJson.buildUrl,
        adGroupMembers: queryparamsJson.adGroupMembers,
        loggedInUser: loggedInUser,
        adminEmails: queryparamsJson.adminEmails,
        domainName: queryparamsJson.domainName,
        skippedBuildEnvironment: queryparamsJson.skippedBuildEnvironment,
        isNewProduct: queryparamsJson.isNewProduct
      });
    }

    this.validateRequest();

  };

  approveFunction = async () => {
    this.setState({ isVisible: true });
    let data = this.getStore();
    //this.setState({ approverValidError: false, isVisible: true });
    var approveAPIResponse = {};
    // Call new lambda function to submit the approval request

    let buildBody = {};
    buildBody = {
        proxyGroupName: data.proxyGroupName,
        adGroup: data.adGroup,
        buildEnvironment: data.buildEnvironment,
        consumerName: data.consumerName,
        appId: JSON.stringify(data.appId),
        status: Utils.APPROVAL,
        buildUrl: data.buildUrl,
        requestor: data.requestor,
        skippedBuildEnvironment: data.skippedBuildEnvironment,
        isNewProduct: data.isNewProduct
      };

    approveAPIResponse = await Utils.approvalStatusAPICall(data, buildBody, "Add Product To Consumer API", "/add-product-to-consumer");

    if (approveAPIResponse.status === Utils.APPROVED) {

      this.setState({ approverSubmitted: true, isVisible: true });
      return;
    } else if (approveAPIResponse.status === Utils.FAILED){

      this.setState({ requestFailed: false, isVisible: false });
    }
  };

  denyFunction = async () => {
    this.setState({ isVisible: true });
    let data = this.getStore();
    //this.setState({ approverValidError: false, isVisible: true });
    // Call new lambda function to submit the approval request
    let buildBody = {};
    var denyAPIResponse = "";
    buildBody = {
        proxyGroupName: data.proxyGroupName,
        adGroup: data.adGroup,
        buildEnvironment: data.buildEnvironment,
        consumerName: data.consumerName,
        appId: JSON.stringify(data.appId),
        status: Utils.DENIAL,
        buildUrl: data.buildUrl,
        requestor: data.requestor,
        skippedBuildEnvironment: data.skippedBuildEnvironment,
        isNewProduct: data.isNewProduct
      };
    denyAPIResponse = await Utils.approvalStatusAPICall(data, buildBody, "Add Product To Consumer API", "/add-product-to-consumer");

    if (denyAPIResponse.status === Utils.DENIED) {

      this.setState({ denialSubmitted: true, isVisible: true });
      return;
    } if (denyAPIResponse.status === Utils.FAILED) {

      this.setState({ requestFailed: true, isVisible: false });
      return;
    } else {

      this.setState({ denialSubmitted: false, isVisible: false });
    }
  };

  getStore = () => {
    return this.state;
  };

  render() {
    let data = this.getStore();
    return (
      <div>
        <h4>Add product to consumer Approval</h4>

        <div className="container util-margin-top-50">
          <hr />
          <div className="row">
            <div className="col-md-3">
              <span>Proxy Group Name: </span>
            </div>
            <div className="col-md-6">
              <span>{data.proxyGroupName}</span>
            </div>
          </div>
           <hr />
          <div className="row">
            <div className="col-md-3">
              <span>AD Group: </span>
            </div>
            <div className="col-md-6">
              <span>{data.adGroup}</span>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-3">
              <span>App ID: </span>
            </div>
            <div className="col-md-6">
              {(() => {
                try {
                  // Check if appId exists and is not empty before parsing
                  if (!data.appId || data.appId === '') {
                    return <span>Loading...</span>;
                  }

                  let appIds = data.appId;
                  if (typeof appIds === 'string') {
                    appIds = JSON.parse(appIds);
                  }

                  return (
                    <div>
                      {appIds && Object.keys(appIds).length > 0 ? (
                        Object.keys(appIds).map((env) => (
                          <div key={env} style={{ marginBottom: '5px' }}>
                            <strong>{env}:</strong> {appIds[env]}
                          </div>
                        ))
                      ) : (
                        <span>No App IDs available</span>
                      )}
                    </div>
                  );
                } catch (e) {
                  console.error('Error parsing appId:', e);
                  return <span>No App IDs available</span>;
                }
              })()}
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-3">
              <span>Consumer Name: </span>
            </div>
            <div className="col-md-6">
              <span>{data.consumerName}</span>
            </div>
          </div>
          <div className="row">
            <hr />
            <div className="col-md-3">
              <span>Requestor: </span>
            </div>
            <div className="col-md-6">
              <span>{data.requestorEmail}</span>
            </div>
          </div>
          <div className="row">
            <hr />
            <div className="col-md-3">
              <span>Build Environment: </span>
            </div>
            <div className="col-md-6">
              <span>{data.buildEnvironment}</span>
            </div>
          </div>
          <div className="row">
            <hr />
            <div className="col-md-3">
              <span>Build Url: </span>
            </div>
           <div className="col-md-6">
               <a href={data.buildUrl} target="_blank" rel="noopener noreferrer">{data.buildUrl} </a>
            </div>
          </div>
          <div className="row">
            <hr />
            <div className="col-md-3">
              <span>Approvers: </span>
            </div>
            <div className="col-md-6">
              <span>{data.adGroupMembers}</span>
            </div>
          </div>
        </div>

        <hr />
        <div>
          <button
            disabled={this.state.isVisible}
            className="btn btn-primary btn-sm pull-left"
            onClick={this.approveFunction}
          >
            Approve
          </button>
          <button style={{"marginLeft":"10px"}}
            disabled={this.state.isVisible}
            className="btn btn-primary btn-sm pull-left"
            onClick={this.denyFunction}
          >
            Deny
          </button>
        </div>

        <br />
        <br />
        {this.state.approverError && (
          <p className="alert alert-danger util-margin-top-10">
            Requestor and approver cannot be same.{this.state.approverError}
          </p>
        )}
        {this.state.approverValidError && (
          <p className="alert alert-danger util-margin-top-10">
            User is not part of the AD Group and cannot approve this request.
            {this.state.approverValidError}
          </p>
        )}
        {this.state.approverSubmitted && (
          <p className="alert alert-success util-margin-top-10">
            Approval Request has been successfully submitted, you will receive an email of its status.
            {this.state.approverSubmitted}
          </p>
        )}
        {this.state.requestSubmitted && (
          <p className="alert alert-success util-margin-top-10">
            This request is already approved by {data.approvedBy}, No action is required.
            {this.state.requestSubmitted}
          </p>
        )}
        {this.state.denialSubmitted && (
          <p className="alert alert-success util-margin-top-10">
            Denial Request has been successfully submitted.{this.state.denialSubmitted}
          </p>
        )}
        {this.state.isExpired && (
          <p className="alert alert-danger util-margin-top-10">
            This request is expired.{this.state.isExpired}
          </p>
        )}
         {this.state.requestDenied && (
          <p className="alert alert-danger util-margin-top-10">
            This request is already denied by {data.deniedBy}, No action is required.{this.state.requestDenied}
          </p>
        )}
        {this.state.requestFailed && (
          <p className="alert alert-danger util-margin-top-10">
            Calling the API is failed, refresh the page and try again.{this.state.requestFailed}
          </p>
        )}
        {this.state.isFutureTime && (
          <p className="alert alert-danger util-margin-top-10">
            Resuested Date cannot be a future date.{this.state.isFutureTime}
          </p>
        )}
      </div>
    );
  }
}

export default RequestsApproverAddProduct;
